import { ROLES, patchElements, uid, textStylePatch } from "./studioModel";

export function styleGroupName(doc, role) {
  return doc.styleGroups?.[role]?.name || ROLES[role];
}
export function styleGroupIds(doc, role) {
  const group = doc.styleGroups?.[role];
  const included = new Set(group?.included || []);
  const excluded = new Set(group?.excluded || []);
  return doc.pages.flatMap((page) =>
    page.elements
      .filter(
        (node) =>
          node.type === "text" &&
          !excluded.has(node.id) &&
          (node.role === role || included.has(node.id))
      )
      .map((node) => node.id)
  );
}
export function updateStyleGroup(doc, role, changes) {
  return {
    ...doc,
    styleGroups: {
      ...doc.styleGroups,
      [role]: {
        name: ROLES[role],
        included: [],
        excluded: [],
        ...doc.styleGroups?.[role],
        ...changes,
      },
    },
  };
}
export function toggleStyleGroupMember(doc, role, id) {
  const node = doc.pages
    .flatMap((page) => page.elements)
    .find((item) => item.id === id);
  if (!node || node.type !== "text") return doc;
  const member = styleGroupIds(doc, role).includes(id);
  const included = new Set(doc.styleGroups?.[role]?.included || []);
  const excluded = new Set(doc.styleGroups?.[role]?.excluded || []);
  included.delete(id);
  excluded.delete(id);
  if (member && node.role === role) excluded.add(id);
  if (!member && node.role !== role) included.add(id);
  return updateStyleGroup(doc, role, {
    included: [...included],
    excluded: [...excluded],
  });
}
export function applyStyleGroup(doc, role, changes) {
  const members = new Set(styleGroupIds(doc, role));
  const editable = doc.pages
    .flatMap((page) => page.elements)
    .filter((node) => members.has(node.id) && !node.locked)
    .map((node) => node.id);
  return patchElements(doc, editable, (node) => textStylePatch(node, changes));
}

export function styleGroupKeys(doc) {
  return [...Object.keys(ROLES).filter((key) => key !== "decoration"),
    ...Object.keys(doc.styleGroups || {}).filter((key) => key.startsWith("custom:"))];
}
export function createStyleGroup(doc, name, selected = []) {
  const trimmed = name.trim();
  if (!trimmed || trimmed.length > 100) throw new Error("Enter a group name (up to 100 characters).");
  if (styleGroupKeys(doc).some((key) => styleGroupName(doc, key).toLowerCase() === trimmed.toLowerCase())) throw new Error("A typography group already uses that name.");
  const id = `custom:${uid()}`;
  const included = doc.pages.flatMap((p) => p.elements).filter((n) => n.type === "text" && selected.includes(n.id)).map((n) => n.id);
  return { id, doc: updateStyleGroup(doc, id, { name: trimmed, included }) };
}
export function deleteStyleGroup(doc, id) {
  if (!id?.startsWith("custom:") || !doc.styleGroups?.[id]) return doc;
  const groups = { ...doc.styleGroups };
  delete groups[id];
  return { ...doc, styleGroups: groups };
}
